import {
  Card,
  Text,
  Grid,
  Divider,
  Stack,
  Flex,
  Tooltip,
} from "@mantine/core";
import React from "react";
import StatusPill from "../../../monitoringQueue/components/MonitoringQueueTable/StatusPill";
import { useCheckPermission } from "../../../../hooks/useCheckPermission";
import { useTranslation } from "react-i18next";
import { resolutionStatuses } from "../../../../utils/vars";
import StatusResolution from "./StatusResolution/StatusResolution";
import { useSelectFlagData } from "../../../../redux/features/flagDetails/flagDetailsSlice";
import dayjs from "dayjs";
import { dateWithHourFormat } from "../../../../utils/dateFormat";

const FlagDetails = () => {
  const { t } = useTranslation();
  const flagData = useSelectFlagData();

  const {
    flagDetails: { id, date, status, resolution, name, assignee, tenant, data },
  } = flagData;

  const resolutionTextPermission = useCheckPermission("RESOLUTION_TEXT");

  const gridBreakpoints = { md: 4, lg: 3, xl: 2 };

  const DetailsSection = ({ title, value, span1 = 6, span2 = 6 }) => {
    return (
      <Grid gap="lg">
        <Grid.Col pr={0} span={6}>
          <Text c="gray.6" size="sm">
            {title}:
          </Text>
        </Grid.Col>
        <Grid.Col p={0} span={6}>
          <Tooltip label={value} disabled={!value}>
            <Text truncate="end" size="sm">
              {value}
            </Text>
          </Tooltip>
        </Grid.Col>
      </Grid>
    );
  };

  return (
    <Card bg="gray.1">
      <Text mb="md" fw={500}>
        {t("flagDetails.details.title")}
      </Text>
      <Flex align="baseline" justify="space-between">
        <Grid w={1600} align="center">
          <Grid.Col miw={280} span={gridBreakpoints}>
            <Stack gap={4}>
              <DetailsSection
                span1={5}
                span2={7}
                title={t("flagDetails.details.flaggedDate")}
                value={dayjs(date).format(dateWithHourFormat)}
              />
              <DetailsSection
                title={t("flagDetails.details.flag")}
                value={id}
              />
            </Stack>
          </Grid.Col>
          {resolutionTextPermission ? (
            <>
              <Divider orientation="vertical" />
              <Grid.Col miw={280} span={gridBreakpoints}>
                <Stack gap={4}>
                  <DetailsSection
                    title={t("flagDetails.details.status")}
                    value={<StatusPill status={status} />}
                  />
                  <DetailsSection
                    title={t("flagDetails.details.resolutionStatus")}
                    value={resolutionStatuses[resolution]}
                  />
                </Stack>
              </Grid.Col>
            </>
          ) : null}

          <Divider orientation="vertical" />
          <Grid.Col miw={280} span={gridBreakpoints}>
            <Stack gap={4}>
              <DetailsSection
                title={t("flagDetails.details.rule")}
                value={name}
              />
              <DetailsSection
                title={t("flagDetails.details.tenant")}
                value={tenant}
              />
            </Stack>
          </Grid.Col>
          <Divider orientation="vertical" />

          <Grid.Col miw={280} span={gridBreakpoints}>
            <Stack gap={4}>
              <DetailsSection
                title={t("flagDetails.details.author")}
                value={data}
              />
              <DetailsSection
                title={t("flagDetails.details.assignee")}
                value={assignee}
              />
            </Stack>
          </Grid.Col>
          <Divider orientation="vertical" />
        </Grid>
        <StatusResolution />
      </Flex>
    </Card>
  );
};

export default FlagDetails;
